var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyList(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 178 158",
    style: {
      enableBackground: "new 0 0 178 158"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#BCBCBC;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M82.4,112H55.5c-2.1,0-3.7-1.7-3.7-3.7V37.8c0-2.1,1.7-3.7,3.7-3.7h35.4c0.6,0,1.2,0.3,1.6,0.8l18.4,18 c1,1,1.5,1.8,1.5,2v23.8c-1.3-0.6-2.7-1-4.2-1.3v-20H90.8c-1.2,0-2.1-1-2.1-2.1v-17H55.9v69.6h24.7C81,109.3,81.7,110.7,82.4,112z  M103.2,82.2c5,0,9.6,2,12.9,5.3s5.3,7.9,5.3,12.9c0,3.7-1.1,7.1-3,10l7.9,8.6l-5.4,5l-7.6-8.4c-2.9,1.9-6.4,3.1-10.1,3.1 c-5,0-9.6-2-12.9-5.3s-5.3-7.9-5.3-12.9s2-9.6,5.3-12.9C93.6,84.3,98.1,82.2,103.2,82.2L103.2,82.2z M113.7,90 c-2.7-2.7-6.4-4.3-10.5-4.3s-7.8,1.7-10.5,4.3c-2.7,2.7-4.3,6.4-4.3,10.5s1.7,7.8,4.3,10.5c2.7,2.7,6.4,4.3,10.5,4.3 s7.8-1.7,10.5-4.3c2.7-2.7,4.3-6.4,4.3-10.5S116.3,92.7,113.7,90z M107.3,93.7l2.5,2.6l-4.1,4.2l4.1,4.2l-2.6,2.5l-4.1-4.1l-4.1,4.1 l-2.5-2.6l4.1-4.2l-4.1-4.2l2.6-2.5l4.1,4.1L107.3,93.7L107.3,93.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyList);
export default __webpack_public_path__ + "static/media/emptyList.94383dc53b89c4c76bed78965c12952c.svg";
export { ForwardRef as ReactComponent };